import React, { useEffect, useState, useContext } from 'react';
import Layout from '../components/Layout';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { BrowserRouter as Router, useHistory, useLocation } from "react-router-dom";
import firebase from "firebase/app";
import { firestore, functions } from '../config/firebase-config';
import AppBar from '@mui/material/AppBar';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import Switch from '@mui/material/Switch';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListSubheader from '@mui/material/ListSubheader';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import GroupIcon from '@mui/icons-material/Group';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Checkbox from '@mui/material/Checkbox';
import Avatar from '@mui/material/Avatar';
import Autocomplete from '@mui/material/Autocomplete';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import UserProvider, { UserContext } from '../components/UserProvider';
import Person2Icon from '@mui/icons-material/Person2';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker, } from '@material-ui/pickers';
//import MobileDatePicker from '@mui/lab/MobileDatePicker';
import Stack from '@mui/material/Stack';
//import LocalizationProvider from '@mui/lab/LocalizationProvider';
//import AdapterDateFns from '@mui/lab/AdapterDateFns';

import { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { palette } from '@mui/system';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';


const useStyles = makeStyles((theme) => ({
    root: {
      maxWidth: '100%',
    },
    header:{
      textAlign: 'center',
      marginBottom: 20,
    },
    pageHeader: {
        display: 'flex',
        marginTop: 54,
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        height: 100,
        backgroundColor: theme.palette.primary.light,
        textAlign: 'left',
        padding: theme.spacing(2),
    },
    forms:{
        marginTop: theme.spacing(3),
        backgroundColor: theme.palette.primary.backgroundCard,
    },
    formControl: {
        minWidth: '100%',
        marginBottom: theme.spacing(3),
    },
    dateField: {
        minWidth: '100%',
        width: '100%',
        marginTop: theme.spacing(1),
    },
    title: {
      marginTop: '80px',
    },
    paathSection: {
        marginTop: theme.spacing(3),
    },
    card: {
        marginTop: theme.spacing(2),
    },
    paathOptions:{
        marginTop: theme.spacing(2),
    },
    groupSelectIcon:{
        marginRight: theme.spacing(1),
    },
    paathiMessageContainer:{
        backgroundColor: theme.palette.primary.background,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    paathiMessage:{
        textAlign: 'center',
        color: theme.palette.primary.main,
        fontSize: 14,
    },
    autoComplete: {
        minWidth: '100%',
        maxWidth: '100%',
        marginTop: theme.spacing(2),
    },
    userNameSearch: {
        minWidth: '100%',
        maxWidth: '100%',
        marginTop: theme.spacing(2),
    },
    addGroupButton: {
        textAlign: 'center',
        marginTop: theme.spacing(2),
    },
    selectedUserSearch: {
        maxWidth: '100%',
        marginTop: theme.spacing(2),
    },
    selectedUsers: {
        marginTop: theme.spacing(2),
    },
    selectedUsersList: {
        width: '100%',
        maxWidth: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 300,
    },
    listSection: {
        backgroundColor: 'inherit',
      },
      ul: {
        backgroundColor: 'inherit',
        padding: 0,
      },
    bottomActionButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(4),
    },
    cancelButton: {
        color: theme.palette.error.main,
    }
}));



const steps = ['Start', 'Paathis', 'Finish'];

const CreatePaathForm = () => {

    const classes = useStyles();
    //const theme = useTheme();
    const history = useHistory();
    const {user, setUser} = useContext(UserContext);
    //const functions = getFunctions();
    const sendPushNotifications = functions.httpsCallable('sendPushNotifications');

    const [loggedInUserId, setLoggedInUserId] = useState("");
    const [value, setValue] = useState(0);
    const [paathTitle, setPaathTitle] = useState('');
    const [paathType, setPaathType] = useState('');
    const [publicPaath, setPublicPaath] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [finishDate, setFinishDate] = useState(null);
    const [participants, setParticipants] = useState([]);
    const [userNameSearchOpen, setUserNameSearchOpen] = useState(false);
    const [userName, setUserName] = useState('');
    const [usersFound, setUsersFound] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([{displayName: user?.displayName, userId: user?.uid, id: user?.userName, email: user?.email}]);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [groupLoading, setGroupLoading] = useState(false);
    const [addingPaath, setAddingPaath] = useState(false);
    const [paathAdded, setPaathAdded] = useState(false);
    const [error, setError] = useState('');
    const [activeStep, setActiveStep] = useState(0);
    const [skipped, setSkipped] = useState(new Set());
    const [savedGroupOpen, setSavedGroupOpen] = useState(false);
    const [savedGroups, setSavedGroups] = useState([]);
    const [groupPaath, setGroupPaath] = useState('single');

    useEffect(() => {

        let foundUser = {displayName: '', userName: '', id: ''};
        if(userName !== ''){
           
            firestore.collection("usernames").doc(userName).get().then((doc) => {
                if(doc.data() === undefined){
                    return;
                }
                else{
                    foundUser = doc.data();
                    foundUser.id = doc.id;
                    //console.log(foundUser);
                    setOptions([foundUser]);
                }
            })
        }
        setLoggedInUserId(user?.uid);

    }, [loading, userName])

    
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1); 
    };
    
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    
    const handleChangeGroupPaath = (event) => {
       setGroupPaath(event.target.value);
    };

    const handleReset = () => {
        setActiveStep(0);
    };
  
    const handleTabChange = (event, newValue) => {
      setValue(newValue);
    };
  
    const handleChangeIndex = (index) => {
      setValue(index);
    };

    const handleChange = (event) => {
        if(event.target.name === 'paath-title'){
            setPaathTitle(event.target.value);
        }
        else if(event.target.name === 'paath-type'){
            setPaathType(event.target.value);
        }
        else if(event.target.name === 'public-paath'){
            setPublicPaath(event.target.checked);
        }
    }

    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const handleFinishDateChange = (date) => {
        setFinishDate(date);
    };

    const handleCancelCreate = () => {
        if(window.confirm("Are you sure you want to cancel creating this Paath?")){
            history.push('/paaths');
        }
        else{
            return;
        }
    }

    const createPaath = (event) => {
        event.preventDefault();
        if (paathTitle === "") {
            alert("Please Complete Paath Title");
        }
        else if (paathType === ""){
            alert("Please Select The Paath Type");
        }
        else if(startDate === null || finishDate === null){
            alert("Please Select Paath Start and Finish Dates");
        }
        else if(startDate.toDate() > finishDate.toDate()){
            alert("The Paath Finish Date Cannot Be Before The Paath Start Date");
        } 
        else {
            setAddingPaath(true);
            firestore.collection("paaths").add({
                createdBy: user.uid,
                createdByDisplayName: user.displayName,
                createdByUserName: user.userName,
                createdAt: new Date(),
                paathTitle,
                paathType,
                paathStatus: 'toStart',
                startDate: startDate.toDate(),
                finishDate: finishDate.toDate(),
                publicPaath: publicPaath,
                progress: {currentPage: 1, currentReader: '', lineNumberMarker: 1, verseNumberMarker: 1, readingStatus: 'toStart'},
                participants: selectedUsers,
                confirmedParticipants: [user.uid],
                declinedParticipants: [],
            }).then((docRef) => {
                addPaathToUserProfile(docRef.id);
                //addPaathToParticipantProfile(docRef.id);
                notifyParticipants(docRef.id);
                sendPushNotificationToParticipants(docRef.id);
                sendEmailToParticipants(docRef.id);
                setPaathAdded(true);
            }).then(() => {
                // setPaathTitle("");
                // setStartDate(new Date());
                // setFinishDate(new Date());
                // setPaathType("");
                // setParticipants([""]);
                //setProgramAdded(true);
                setTimeout(() => setAddingPaath(false), 1000);
                setTimeout(() => history.push('/paaths'), 1000);
            }).catch((error) => {
                setAddingPaath(false);
                console.error("Error writing document: ", error);
                setError("Error adding paath: ", error);
            });
        }
    }

    // Add's paath to user's profile
    const addPaathToUserProfile = (id) => {
        const currentPaaths = user.paaths;
        const userDocRef = firestore.collection("users").doc(user.uid);
        userDocRef.update({
            paaths: [...currentPaaths, id]
        }).then(() => { 
           return userDocRef.get(); 
        }).then((doc) => {
            let uid = doc.id;
            let userData = doc.data();
            let updatedUser = {uid, ...userData};
            setUser(updatedUser);
        })
        .catch((error) => {
            console.error("Error updating document: ", error);
                setError("Error adding program: ", error);
        });
    }

    // Add's the newly created paath to each one of the participants profile
    // So this paath shows up in their Ongoing Paaths Tab
    const addPaathToParticipantProfile = (id) => {
        selectedUsers.forEach((user) => {
            firestore.collection("users").doc(user.userId).update({
              paaths:  firebase.firestore.FieldValue.arrayUnion(id)
            })
        })
    }

    // Updates each participants notifications collection with a message they've been added to a paath.
    // The participant then has to accept or decline the paath invitation for the paath to show up
    // for that user.
    const notifyParticipants = (id) => {
        const paathCreatedBy = user.uid;
        selectedUsers.forEach((user) => {
            firestore.collection("notifications").doc(user.userId).update({
              userNotification:  firebase.firestore.FieldValue.arrayUnion({
                  date: new Date(),
                  description: "",
                  paathCreatedBy: paathCreatedBy,
                  paathId: id,
                  paathTitle,
                  read: false,
                  title: "You've Been Added To a Paath",
                  type: "addedToPaath"
                })
            })
        })
    }

    // This will call the FCM cloud function and send a push notification
    // to each participant.
    const sendPushNotificationToParticipants = (id) => {
         const selectedUserIds = [];
         selectedUsers.filter((user) => {  
            let id = user.userId;
            selectedUserIds.push(id);
            return selectedUserIds;
         })
         //console.log(selectedUserIds);
         const data = {paathId: id, paathTitle: paathTitle , userIds: selectedUserIds, message: "You've Been Added To a New Paath"};
         const context = user.uid;
         sendPushNotifications(data, context).then((result) => {
             console.log(result);
         }).catch((error) => {
             console.log(error);
         });
    }

    // Sends User Email that they've been added to a paath
   const sendEmailToParticipants = async (id) => {
    let userEmailAllowed;
    const selectedUserEmails = [];
    selectedUsers.filter((user) => {  
        let email = user.email;
        selectedUserEmails.push(email);
        return selectedUserEmails;
     })
    //Gets the user document to check their email notificaiton preferences.
    //await firestore.collection('users').doc(userId).get().then((doc) => userEmailAllowed = doc.data().preferences.emailNotification);
    //Send the user a they've been added to a paath email if they have email notifications enabled.
     selectedUserEmails.forEach((email => {
        firestore.collection('mail').add({
            to: email,
            message: {
                subject: `MySehajPaath - You've Been Added To a New Paath - ${paathTitle}`,
                html: `<!doctype html>
                <html>
                  <head>
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
                    <title>Simple Transactional Email</title>
                    <style>
                @media only screen and (max-width: 620px) {
                  table.body h1 {
                    font-size: 28px !important;
                    margin-bottom: 10px !important;
                  }
                
                  table.body p,
                table.body ul,
                table.body ol,
                table.body td,
                table.body span,
                table.body a {
                    font-size: 16px !important;
                  }
                
                  table.body .wrapper,
                table.body .article {
                    padding: 10px !important;
                  }
                
                  table.body .content {
                    padding: 0 !important;
                  }
                
                  table.body .container {
                    padding: 0 !important;
                    width: 100% !important;
                  }
                
                  table.body .main {
                    border-left-width: 0 !important;
                    border-radius: 0 !important;
                    border-right-width: 0 !important;
                  }
                
                  table.body .btn table {
                    width: 100% !important;
                  }
                
                  table.body .btn a {
                    width: 100% !important;
                  }
                
                  table.body .img-responsive {
                    height: auto !important;
                    max-width: 100% !important;
                    width: auto !important;
                  }
                }
                @media all {
                  .ExternalClass {
                    width: 100%;
                  }
                
                  .ExternalClass,
                .ExternalClass p,
                .ExternalClass span,
                .ExternalClass font,
                .ExternalClass td,
                .ExternalClass div {
                    line-height: 100%;
                  }
                
                  .apple-link a {
                    color: inherit !important;
                    font-family: inherit !important;
                    font-size: inherit !important;
                    font-weight: inherit !important;
                    line-height: inherit !important;
                    text-decoration: none !important;
                  }
                
                  #MessageViewBody a {
                    color: inherit;
                    text-decoration: none;
                    font-size: inherit;
                    font-family: inherit;
                    font-weight: inherit;
                    line-height: inherit;
                  }
                
                  .btn-primary table td:hover {
                    background-color: #34495e !important;
                  }
                
                  .btn-primary a:hover {
                    background-color: #34495e !important;
                    border-color: #34495e !important;
                  }
                }
                </style>
                  </head>
                  <body style="background-color: #f6f6f6; text-align: center; font-family: sans-serif; -webkit-font-smoothing: antialiased; font-size: 14px; line-height: 1.4; margin: 0; padding: 0; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%;">
                    <table role="presentation" border="0" cellpadding="0" cellspacing="0" class="body" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #f6f6f6; width: 100%;" width="100%" bgcolor="#f6f6f6">
                      <tr>
                        <td style="font-family: sans-serif; font-size: 14px; vertical-align: top;" valign="top">&nbsp;</td>
                        <td class="container" style="font-family: sans-serif; font-size: 14px; vertical-align: top; display: block; max-width: 580px; padding: 10px; width: 580px; margin: 0 auto;" width="580" valign="top">
                          <div class="content" style="box-sizing: border-box; display: block; margin: 0 auto; max-width: 580px; padding: 10px;">
                
                            <!-- START CENTERED WHITE CONTAINER -->
                            <table role="presentation" class="main" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; background: #ffffff; border-radius: 3px; width: 100%;" width="100%">
                
                              <!-- START MAIN CONTENT AREA -->
                              <tr>
                                <td class="wrapper" style="font-family: sans-serif; font-size: 14px; vertical-align: top; box-sizing: border-box; padding: 20px;" valign="top">
                                  <table role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;" width="100%">
                                  <img src="http://mysehajpaath.com/wp-content/uploads/2022/03/MSP-Final-Gold-300.png" style="width: 100px; height: auto; margin-bottom: 15px" alt="My Sehaj Paath Logo"/>   
                                  <tr>
                                      <td style="font-family: sans-serif; font-size: 14px; vertical-align: top;" valign="top">
                                        <p style="font-family: sans-serif; font-size: 20px; font-weight: bold; margin: 0; margin-bottom: 15px;">You've Been Added To A New Paath</p>
                                        <p style="font-family: sans-serif; font-size: 18px; font-weight: normal; margin: 0; margin-bottom: 15px;">Please Sign In To The MySehajPaath App and Accept the Paath Invite From Your Notifications.</p>
                                        <p style="font-family: sans-serif; font-size: 18px; font-weight: normal; margin: 0; margin-bottom: 20px;">Paath Title: ${paathTitle}</p>
                                        <table role="presentation" border="0" cellpadding="0" cellspacing="0" class="btn btn-primary" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; box-sizing: border-box; width: 100%;" width="100%">
                                          <tbody>
                                            <tr>
                                              <td align="center" style="font-family: sans-serif; font-size: 14px; vertical-align: top; padding-bottom: 15px;" valign="top">
                                                <table role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: auto;">
                                                  <tbody>
                                                    <tr>
                                                      <td style="font-family: sans-serif; font-size: 14px; vertical-align: top; border-radius: 5px; text-align: center; background-color: #3498db;" valign="top" align="center" bgcolor="#3498db"> 
                                                        <a href="https://app.mysehajpaath.com/paaths/${id}" target="_blank" style="border: solid 1px #5A8087; border-radius: 5px; box-sizing: border-box; cursor: pointer; display: inline-block; font-size: 14px; font-weight: bold; margin: 0; padding: 10px 20px; text-decoration: none; text-transform: capitalize; background-color: #5A8087; border-color: #5A8087; color: #ffffff;">View Paath</a> 
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                
                            <!-- END MAIN CONTENT AREA -->
                            </table>
                            <!-- END CENTERED WHITE CONTAINER -->
                
                            <!-- START FOOTER -->
                            <div class="footer" style="clear: both; margin-top: 10px; text-align: center; width: 100%;">
                              <table role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;" width="100%">
                                <tr>
                                  <td class="content-block" style="font-family: sans-serif; vertical-align: top; padding-bottom: 10px; padding-top: 10px; color: #999999; font-size: 12px; text-align: center;" valign="top" align="center">
                                    <span class="apple-link" style="color: #999999; font-size: 12px; text-align: center;">MySehajPaath</span>
                                  </td>
                                </tr>
                              </table>
                            </div>
                            <!-- END FOOTER -->
                
                          </div>
                        </td>
                        <td style="font-family: sans-serif; font-size: 14px; vertical-align: top;" valign="top">&nbsp;</td>
                      </tr>
                    </table>
                  </body>
                </html>`,
            },
        })
     }))
    }

    const handleAddUser = (user, index) => {
        let updatedUser = user;
        //updatedUser.inviteAccepted = "pending";
        setSelectedUsers([...selectedUsers, updatedUser]);
    }

    const handleRemoveUser = (index) => {
        const updatedUserList = selectedUsers.filter((_, i) => i !== index);
        setSelectedUsers(updatedUserList);
    }

    const addFromSavedGroup = () => {
        setSavedGroupOpen(true);
        fetchUserSavedGroups();
    }

    const handleCloseSavedGroup = (value) => {
        setSavedGroupOpen(false);
        //setting a timeout here because the saved group list clears
        // before the dialog completely closes causing an ugly visual transition.
        setTimeout(() => setSavedGroups([]), 500);
       // setSelectedValue(value);
    };

    const fetchUserSavedGroups = async () => {
        const fetchedGroup = []; 
        if(user?.savedGroups?.length > 0){
            await user.savedGroups.forEach((id) =>
                 firestore.collection("savedGroups").doc(id).get().then((doc) => {
                    if(doc.exists){
                        setGroupLoading(true);
                        const group = doc.data();
                        group.id = doc.id;
                        fetchedGroup.unshift(group)
                        //console.log(fetchedPaath);
                        setSavedGroups(...savedGroups, fetchedGroup);
                        setGroupLoading(false);
                    }
            }));
        }
    }

    const handleGroupSelect = (group) => {
        const groupUsers = group.users;
        setSelectedUsers(groupUsers);
        handleCloseSavedGroup();
    }


    const renderStepForm = (activeStep) => {
        if(activeStep === 0){
            return(
                <Card className={classes.forms} variant="outlined">
                    <CardContent>
                    <TextField onChange={handleChange} value={paathTitle} variant="outlined" margin="normal" fullWidth id="paath-title" label="Paath Title" name="paath-title" />
                    {/* Paath Type */}
                    <FormControl variant="outlined" margin="normal" className={classes.formControl}>
                        <InputLabel id="paath-type-label">Paath Type</InputLabel>
                        <Select labelId="paath-type" id="paath-type" name="paath-type" value={paathType} onChange={handleChange} label="Paath Type" >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        <MenuItem value={'sehaj'}>Sehaj Paath</MenuItem>
                        </Select>
                    </FormControl>
                    <Stack spacing={3}>
                    {/* Paath Start Date */}
                        <MobileDatePicker id="start-date" label="Start Date" margin="normal" value={startDate} onChange={handleStartDateChange} className={classes.dateField} renderInput={(params) => <TextField {...params} />} />
                        {/* Paath End Date */}
                        <MobileDatePicker id="finish-date" label="Finish Date" margin="normal" value={finishDate} onChange={handleFinishDateChange} className={classes.dateField} renderInput={(params) => <TextField {...params} />} />
                    </Stack>
                    {/* Public Paath */}
                    <div className={classes.paathOptions}>
                       {/* <FormControlLabel control={ <Switch checked={publicPaath} onChange={handleChange} name="public-paath" color="primary" /> } label="Public Paath"/> */}
                    </div>
                    </CardContent>
                </Card>
            )
        }
        else if(activeStep === 1){
            return(
                <Card className={classes.forms} variant="outlined">
                    <CardContent>
                    <ToggleButtonGroup color="primary" size="small" fullWidth value={groupPaath} exclusive onChange={handleChangeGroupPaath} aria-label="Group Paath" >
                        <ToggleButton value="single"> <Person2Icon className={classes.groupSelectIcon}/> </ToggleButton>
                        <ToggleButton value="group"> <GroupAddIcon className={classes.groupSelectIcon}/> </ToggleButton>
                    </ToggleButtonGroup>
        
                    {groupPaath === 'group' ? 
                    <div>
                        <Paper className={classes.paathiMessageContainer} variant="outlined">
                            <p className={classes.paathiMessage}>You can add other paathis by username, by saved groups, or by sharing the paath link after creating your paath.</p>
                        </Paper>
                        <TextField label="Search Username to Add" variant="outlined" value={userName} className={classes.userNameSearch} onChange={(event) => setUserName(event.target.value)} 
                        InputProps={{ endAdornment: ( <React.Fragment> {loading ? <CircularProgress color="inherit" size={20} /> : null} </React.Fragment> ), }} />
                            <List dense className={classes.selectedUserSearch}>
                                <Divider />

                                    {options ? options.map((user, index) => {

                                    return(
                                        <ListItem button key={index} onClick={() => handleAddUser(user, index)}>
                                            <ListItemAvatar> <Avatar> </Avatar> </ListItemAvatar>
                                            <ListItemText primary={user.displayName} secondary={user.userName} />
                                            {/* <ListItemSecondaryAction> <IconButton edge="end" aria-label="delete"> <DeleteIcon /> </IconButton> </ListItemSecondaryAction> */}
                                        </ListItem>
                                        )
                                    }) : ''}

                                <Divider />
                            </List>

                            <div className={classes.addGroupButton}>
                                <Button variant="outlined" onClick={addFromSavedGroup}>Add Paathis From Saved Group</Button>
                            </div>
                        </div>
                        :
                        <Paper className={classes.paathiMessageContainer} variant="outlined"> 
                            <p className={classes.paathiMessage}>Create a paath just for yourself. You will be the only reader. You can always add others later.</p>
                        </Paper>
                        }

                        <div className={classes.selectedUsers}>
                            <List className={classes.selectedUsersList} subheader={<li />}>
                                
                                    <li className={classes.listSection}>
                                        <ul className={classes.ul}>
                                            <ListSubheader>Selected Users</ListSubheader>
                                            {selectedUsers.map((user, index) => (
                                                <ListItem key={user?.displayName}>
                                                    <ListItemText primary={user?.displayName} secondary={user?.id}/>
                                                    <ListItemSecondaryAction> 
                                                        { loggedInUserId === user?.userId ? "Admin" : <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveUser(index)} size="large"> <DeleteIcon /> </IconButton> }
                                                    </ListItemSecondaryAction> 
                                                </ListItem>
                                            ))}
                                        </ul>
                                    </li>
                            
                            </List>
                        </div>
                    </CardContent>
                </Card>
            )
        }
        else if(activeStep === 2){
            return(
                <Card className={classes.forms} variant="outlined">
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="h2">
                            Paath Details
                        </Typography>
                        <Typography variant="body2" color="textSecondary" component="p">
                            Paath Title
                        </Typography>
                        <Typography variant="h6" color="textSecondary" component="p" gutterBottom>
                            {paathTitle ? paathTitle : "No Title Set"}
                        </Typography>
                    
                        <Typography variant="body2" color="textSecondary" component="p">
                            Paath Type
                        </Typography>
                        <Typography variant="h6" color="textSecondary" component="p" gutterBottom>
                            {paathType ? paathType : "Please Select Paath Type"}
                        </Typography>

                        <Typography variant="body2" color="textSecondary" component="p">
                            Start Date
                        </Typography>
                        <Typography variant="h6" color="textSecondary" component="p" gutterBottom>
                            {startDate?.toString()}
                        </Typography>

                        <Typography variant="body2" color="textSecondary" component="p">
                            Finish Date
                        </Typography>
                        <Typography variant="h6" color="textSecondary" component="p" gutterBottom>
                            {finishDate?.toString()}
                        </Typography>

                        <Typography variant="body2" color="textSecondary" component="p">
                            Public Paath
                        </Typography>
                        <Typography variant="h6" color="textSecondary" component="p" gutterBottom>
                            {publicPaath ? "This Paath is Public" : "This Paath is Private"}
                        </Typography>

                        <Typography variant="body2" color="textSecondary" component="p">
                            Paathis
                        </Typography>
                        <Typography variant="h6" color="textSecondary" component="p" gutterBottom>
                            {
                            selectedUsers.length === 0 ? "No Paathis Added" 
                            : 
                            selectedUsers.map((user, index) => (
                                <div> 
                                <Typography key={index} variant="h6" color="textSecondary" component="p" gutterBottom>
                                    {user?.displayName} 
                                </Typography>
                                <Divider/>
                                </div>
                            ))
                            }
                        </Typography>
                    </CardContent>     
                </Card>
            )
        }
    }


    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
             <Box sx={{ width: '100%', paddingTop: 3 }}>
                 <Stepper activeStep={activeStep}>
                     {steps.map((label, index) => {
                     const stepProps = {};
                     const labelProps = {};
                     return (
                         <Step key={label} {...stepProps}>
                         <StepLabel {...labelProps}>{label}</StepLabel>
                         </Step>
                     );
                     })}
                 </Stepper>
                <React.Fragment>
                {/* Main From Rendered*/}    
                {renderStepForm(activeStep)}
                
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Button className={classes.cancelButton} onClick={handleCancelCreate} sx={{ mr: 1 }} >
                            Cancel
                        </Button>
                        <Button color="inherit" disabled={activeStep === 0} onClick={handleBack} sx={{ mr: 1 }} >
                            Back
                        </Button>

                        <Box sx={{ flex: '1 1 auto' }} />
                
                        {activeStep === steps.length - 1 ? 
                        
                        <LoadingButton onClick={createPaath} loading={addingPaath} loadingIndicator="Creating..." variant="outlined" >
                         Create Paath
                        </LoadingButton>
                        : 
                        <Button onClick={handleNext}>
                            Next
                        </Button>
                        }
                    </Box>
                </React.Fragment>
            </Box>   
           
             <Dialog onClose={handleCloseSavedGroup} open={savedGroupOpen}>
                <DialogTitle>Select Saved Group</DialogTitle>
                    <List sx={{ pt: 0 }}>
                    
                    {savedGroups ? savedGroups?.map((group) => (
                        <ListItem button onClick={() => handleGroupSelect(group)} key={group.groupName}>
                            <ListItemAvatar>
                                <Avatar>
                                <GroupIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={group.groupName} />
                        </ListItem>
                    )) :
                    groupLoading ? <ListItem><CircularProgress size={25}/></ListItem> : <ListItem><ListItemText primary={"No Saved Groups."} /></ListItem>
                    }
            
                    </List>
                <DialogActions>
                    <Button onClick={handleCloseSavedGroup}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </LocalizationProvider>
    );
}

export default CreatePaathForm;